// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"93":"ef372a262476ae271930","350":"bbbf102c750cfc4d89ba","536":"b8d5ae01f20065319970","839":"861a4afd39e32c5b2d1b","926":"2c5251244d9ff3cb1b00","961":"cc5b608e9892ef044b1a"}[chunkId] + ".chunk.js";
};